import React, { useState } from 'react'
import { Button } from '@mui/material'
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './NewUserProgramForm.css'
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';

export default function SendMessageForm({ usertoken, handleCloseSendMessageForm, isGroupMessage = false }) {
    const [response, setResponse] = useState(null);
    const [title, setTitle] = useState('')
    const [message, setMessage] = useState('')

    const [userGroup, setUserGroup] = useState('')
    const allUsers = useSelector((state) => state.user.allUsers)

    const userCategories = []
    allUsers && allUsers.map(u => {
        if (!userCategories.find(c => c === u.usergroup)) {
            userCategories.push(u.usergroup)
        }
        return null
    })

    const sendData = async (title, message) => {
        const notification = {
            title: title,
            body: message,
            sound: "default",
            mutable_content: true,
            category: "Kudos"
        }
        const messageBody = {
            to: usertoken,
            notification: notification,
            priority: "high",
            content_available: false
        }

        const url = "https://fcm.googleapis.com/fcm/send";
        const token = "AAAA0ibnjpY:APA91bHfC8NV-BL0WhD2pQ8DHqGRacho_gNYVeN5hViSss1Y_ZzKbyIcCm7zlSTMsMrVpa2g6Hny92fT1-z18UzZCYoX53MQQsKVn7jRP8zlJT0iLWhk4S0N-_HvsrfrkSewc3-Hml0c"

        try {
            const response = await fetch(url, {
                method: 'POST', // or 'PUT'
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(messageBody),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            } else {
                const json = await response.json();
                setResponse("Melding sendt! " + json);
            }
        } catch (error) {
            setResponse("Kunne ikke sende melding:", error);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (isGroupMessage) {
            allUsers && allUsers.map(u => {
                if (u.usergroup === userGroup) {
                    usertoken = u.usertoken
                    // console.log("sendData: " + usertoken) 
                    sendData(title, message)
                }
            }) 
        } else {
            sendData(title, message)
        }
        handleCloseSendMessageForm()
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%', mt: 1 }}>
                {isGroupMessage &&
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={userCategories}
                        sx={{ width: '100%', mt: 3 }}
                        renderInput={(params) => <TextField {...params} label="Brukergruppe *" />}
                        onChange={(event, newValue) => {
                            setUserGroup(newValue);
                        }}
                    />
                }
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="title"
                    label="Emne"
                    name="title"
                    autoComplete="title"
                    value={title}
                    onChange={(event) => {
                        setTitle(event.target.value);
                    }}
                />
                <TextField
                    margin="normal"
                    required
                    multiline
                    rows={4}
                    fullWidth
                    id="message"
                    label="Melding"
                    name="message"
                    autoComplete="message"
                    value={message}
                    onChange={(event) => {
                        setMessage(event.target.value);
                    }}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Send
                </Button>
                {/* <p>{response}</p> */}
            </Box>
        </Box>
    )
}
